module.exports = __webpack_public_path__ + "static/media/unchecked_radio.12775681.svg";